import Swiper from 'swiper/js/swiper';

function initDefaultSlider(slider) {
    const sliderContainer = slider;
    const sliderContainerParent = sliderContainer.parentElement;
    const sliderParams = {
        speed: 600,
        navigation: {
          nextEl: sliderContainerParent.querySelector('.theme-swiper-button-next'),
          prevEl: sliderContainerParent.querySelector('.theme-swiper-button-prev'),
        },
        pagination: {
          el: sliderContainerParent.querySelector(".swiper-pagination"),
          clickable: true,
          renderBullet: function (index, className) {
            return (
            `<span class="swiper-pagination-bullet">
                <svg id="black-rectangle" width="20" height="20">
                    <rect fill="currentColor" width="20" height="20" style="stroke-width:0;stroke:rgb(0,0,0)" />
                </svg>
            </span>`
            );
          },
        },
    };
    if(sliderContainerParent.classList.contains('autoheight')){
        sliderParams.autoHeight = true;
    }

    if(sliderContainerParent.classList.contains('fade')){
        sliderParams.effect = 'fade';
    }

    const homeSlider = new Swiper(sliderContainer, sliderParams );

    sliderParams.navigation.nextEl.addEventListener("click", ()=>{
        ariaHidden();
    });
    sliderParams.navigation.prevEl.addEventListener("click", ()=>{
        ariaHidden();
    });

};


const ariaHidden = () => {
    let allSlidesDivs = document.querySelectorAll(".swiper-slide div");
    let visibleSlide = document.querySelectorAll(".swiper-slide-active div");
    for(var i=0; i < allSlidesDivs.length;i++){
        allSlidesDivs[i].setAttribute("aria-hidden","true");
        allSlidesDivs[i].setAttribute("tabindex","-1");
        if(allSlidesDivs[i].classList.contains("rooms-slider-link")){
            allSlidesDivs[i].classList.add("swiper-slide-hidden");
        };
    }
    visibleSlide.forEach(element => {
        element.setAttribute("aria-hidden","false");
        // element.setAttribute("tabindex","0");
        if(element.classList.contains("rooms-slider-link")){
            element.classList.remove("swiper-slide-hidden");
            // element.setAttribute("tabindex","-1");
        };
    });
}

document.addEventListener('DOMContentLoaded', () => {
    const sliders = document.querySelectorAll('.swiper-container');
    if (sliders.length) {
        for (let i = 0; i < sliders.length; i++) {
            initDefaultSlider(sliders[i]);
        }
        ariaHidden();
    }
});



// WEBPACK FOOTER //
// ./assets/src/js/modules/swiper.js